// import logo from './images/logo.svg';
import './App.scss';
import {
	Footer,
	Header,
} from './Components';
import beer from './media/beer.jpg';
import React from 'react';
import v60 from './media/v60.jpg';

class App extends React.Component {

	constructor(props) {

		super(props);

		this.state = ({
			checked:false,
			scrolled: false,
		});

	}

	handleTermsScroll = (e) => {
		const { target } = e;
		// console.log(target.scrollHeight, target.scrollTop, target.clientHeight, target.scrollHeight - target.scrollTop);
		if (target.scrollHeight - target.scrollTop <= (target.clientHeight + 4)) {
			// console.log("terms scroll", e);
			this.setState({
				scrolled: true
			});
		}
	};

	handleTermsChecked = (e) => {
		// console.log("terms checked", e);
		const { target } = e;
		const {
			scrolled = false,
		} = this.state;
		if (!scrolled){
			e.preventDefault();
			// console.log("nowt!");
			alert("Please read the terms and conditions.");
			return;
		}

		// console.log("target.checked", target.checked);
		this.setState({
			checked: target.checked,
		});

	};

	doNowt = (e) => {
		const {
			checked = false,
			scrolled = false,
		} = this.state;
		// console.log("checked", checked, "scrolled", scrolled);
		if (!scrolled){
			e.preventDefault();
			// console.log("nowt!");
			alert("Please read the terms and conditions.");
			return;
		}
		if (!checked) {
			e.preventDefault();
			// console.log("nowt!");
			alert("please confirm you have read the terms and conditions by clicking the checkbox.");
		}
	};

	render() {
		const { scrolled = false } = this.state;
		const terms = `Copyright (c) 2024 Richard Bagnall

YOU WILL NOT PASS THIS WORK OFF AS YOUR OWN OR USE IT FOR COMMERCIAL GAIN.

IF YOU SHARE THIS SOFTWARE YOU WILL CREDIT THE CREATOR (Richard Bagnall).

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

I WILL NOT USE MY PHONE (UNLESS HANDS FREE) WHILE DRIVING BECAUSE I KNOW
THAT IS A STUPID, INCONSIDERATE AND DANGEROUS THING TO DO.`;

		return (
			<div className="app">
				<Header />
				<div className="content">
					<p>If you have a Volvo V60 or S60 with the old style body, you might be interested in this.</p>

					<div className='centre'>
						<img className='frame' src={v60} title={`Volvo V60`} alt={`Volvo V60`}/>
					</div>
					<p>I don't drink coffee and if I did, I probably wouldn't in my car.
						But I do have a phone and find it quite fiddly to plug it in to the USB socket
						in the rear console compartment and it rattles around in the console.</p>
					<div className='frame'>
						<iframe
							width="560"
							height="315"
							src="https://www.youtube.com/embed/VdTvOj7ArGo?si=hNtYorKWV2av_vp8"
							title="YouTube video player"
							frameBorder="0"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
							referrerPolicy="strict-origin-when-cross-origin"
							allowFullScreen></iframe>
					</div>
					<p>I thought I'd make better use of the space (for me at least), so I came up with this wireless chargepad mount.</p>
					<p>You'll need a 3d printer or a friend who has access to one.</p>
					<h2>Components you need</h2>
					<ol>
						<li>Flush USB charger for cigarette lighter socket <a href='https://horizein.com.au/products/30w-mini-car-charger-lighter-fast-charging' target='_blank' rel="noreferrer">which can be bought here</a>. Use code VOLVO15 for 15% off.</li>
						<li>Anker charge pad</li>
						<li>USB ribbon cable (From AliExpress)</li>
					</ol>
					<p>Please read the terms and conditions:</p>
					<textarea id='terms' onScroll={this.handleTermsScroll} defaultValue={terms}></textarea>
					<p>I have read the terms and conditions <input onClick={this.handleTermsChecked} title={`${scrolled ? 'Click to agree to terms and conditions' : 'Please read the terms and conditions first'}`} className={`${scrolled ? 'enabled' : 'disabled'}`} type='checkbox' id='haveread'></input></p>
					<div id='twocolumns'>
						<div id='files'>
							<h2>Printer files</h2>
							<p>Here you will find  a file that suits your 3d printer. I suggest you set it up so that the top of the mount is printed as the first layer as it may look nicer and need less supporting material. Use TPU filament if you can. If not, be careful not to snap the mount when fitting it.</p>
							<ul>
								<li><a onClick={this.doNowt} className='filelink' download target='_blank' href='/printerfiles/Polestar Charger Holder v12 v1.3mf'>Polestar Charger Holder v12 v1.3mf</a></li>
								<li><a onClick={this.doNowt} className='filelink' download target='_blank' href='/printerfiles/Polestar Charger Holder v12 v1.f3d'>Polestar Charger Holder v12 v1.f3d</a></li>
								<li><a onClick={this.doNowt} className='filelink' download target='_blank' href='/printerfiles/Polestar Charger Holder v12 v1.fbx'>Polestar Charger Holder v12 v1.fbx</a></li>
								<li><a onClick={this.doNowt} className='filelink' download target='_blank' href='/printerfiles/Polestar Charger Holder v12 v1.ipt'>Polestar Charger Holder v12 v1.ipt</a></li>
								<li><a onClick={this.doNowt} className='filelink' download target='_blank' href='/printerfiles/Polestar Charger Holder v12 v1.mtl'>Polestar Charger Holder v12 v1.mtl</a></li>
								<li><a onClick={this.doNowt} className='filelink' download target='_blank' href='/printerfiles/Polestar Charger Holder v12 v1.obj'>Polestar Charger Holder v12 v1.obj</a></li>
								<li><a onClick={this.doNowt} className='filelink' download target='_blank' href='/printerfiles/Polestar Charger Holder v12 v1.skp'>Polestar Charger Holder v12 v1.skp</a></li>
								<li><a onClick={this.doNowt} className='filelink' download target='_blank' href='/printerfiles/Polestar Charger Holder v12 v1.smt'>Polestar Charger Holder v12 v1.smt</a></li>
								<li><a onClick={this.doNowt} className='filelink' download target='_blank' href='/printerfiles/Polestar Charger Holder v12 v1.step'>Polestar Charger Holder v12 v1.step</a></li>
								<li><a onClick={this.doNowt} className='filelink' download target='_blank' href='/printerfiles/Polestar Charger Holder v12 v1.stl'>Polestar Charger Holder v12 v1.stl</a></li>
								<li><a onClick={this.doNowt} className='filelink' download target='_blank' href='/printerfiles/Polestar Charger Holder v12 v1.usdz'>Polestar Charger Holder v12 v1.usdz</a></li>
							</ul>
						</div>
						<div id='beer'>
							<p>If you like this product, you can<br/>
								<a href='https://paypal.me/bagnallrichard?country.x=GB&locale.x=en_GB'>buy me a pint if you're feeling generous!</a></p>
							<a href='https://paypal.me/bagnallrichard?country.x=GB&locale.x=en_GB'><img className='frame' src={beer} alt={`beer`}/></a>
						</div>

					</div>
				</div>
				<Footer />
			</div>
		);
	}
}

export default App;